import {Storage} from 'storages/storage';

export default abstract class ConstraintsHandler {
    protected operationData;
    protected state;
    protected executable;
    protected store;
    constructor(args) {
        const {state, executable = {}} = args;

        this.operationData = {
            constraints: {
                base: {},
                afterCreating: {},
            },
        };
        this.state = state;
        this.executable = executable;
        this.store = new Storage();
    }

    public addLineup(simplexLineup): void {
        let lineupsQuantity = this.store.get('calculatedLineupsCount', 0);
        this.store.set('calculatedLineupsCount', ++lineupsQuantity);

        let usedPlayers = this.store.get('usedPlayers', []);
        usedPlayers.push(simplexLineup.getPlayerIds());
        this.store.set('usedPlayers', [...usedPlayers]);

        let usedGroups = this.store.get('usedTeamGroups', []);
        usedGroups.push(simplexLineup.getTeamGroups());
        this.store.set('usedTeamGroups', [...usedGroups]);

        const subGroupTeamNames = simplexLineup.getSubGroupTeamNames();
        !isEmpty(subGroupTeamNames) && this.store.patchArr('usedSubGroupTeams', subGroupTeamNames);

        let lineups = this.store.get('lineups', []);
        lineups.push('+' + simplexLineup.getUnits().join('+'));
        this.store.set('lineups', [...lineups]);
    }

    public doExecutable(methodName: string, args = {}, defaultValue = null): any {
        if (this.executable.hasOwnProperty(methodName)) {
            return this.executable[methodName](cp(this.operationData), args);
        }

        return defaultValue;
    }

    public setToHandlerStore(key, value): void {
        this.store.set(key, value);
    }

    public abstract getConstraints(): any;
}
